// extracted by mini-css-extract-plugin
export var text = "_4k-0";